import {
  ILogRowData,
  addOwnerItemToArray,
  downloadJsonAsCsv,
  getCsvFilename,
} from "../utils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { BasePieChart, IChartGroup } from "../Components/BasePieChart";
import apiAgent from "../../../api/apiAgent";
import { analyticsChartModels } from "../config";
import { IDateRange } from "../Components/DateRangeSelector";

const ModelChart = ({
  model,
  displayData,
  combineMinimum,
  dateRange,
  appId,
}: {
  model: keyof typeof analyticsChartModels;
  displayData: ILogRowData[];
  combineMinimum?: boolean;
  dateRange: IDateRange;
  appId: string;
}) => {
  const [modelData, setModelData] = useState<any[]>([]);

  const fetchModelData = async () => {
    try {
      const { data } = await apiAgent.DataType.getAll(model);
      if (model === "media") {
        const getOwnerData = await addOwnerItemToArray(data);
        setModelData(getOwnerData || data);
      } else setModelData(data);
    } catch (err) {
      console.warn("Unable to fetch data - no display names added");
    }
  };

  useEffect(() => {
    fetchModelData();
  }, []);

  // Update group
  const data = displayData.reduce((arr: IChartGroup[], item) => {
    const itemData = item.logItemData?.find((o) => o.model === model);
    if (itemData && itemData.id) {
      const getItem = modelData.find((m) => m.id === itemData.id);
      const name =
        getItem?.ownerItem !== undefined
          ? `${getItem.ownerItem?.main_title || getItem.ownerItem?.title} > ${
              getItem?.type || model
            } > ${itemData.id}`
          : getItem?.main_title ||
            getItem?.title ||
            `${getItem?.type || model} > ${itemData.id}`;
      const existsInArray = arr.findIndex((i) => i.name === name);
      if (existsInArray !== -1) {
        arr[existsInArray].value++;
      } else
        return [
          ...arr,
          {
            name,
            value: 1,
            link: item.logItemUrl,
          },
        ];
    }
    return arr;
  }, []);

  const displayName = analyticsChartModels[model];

  return data.length > 0 ? (
    <>
      <div className="flex gap-2">
        <div>
          Top 10<span className="font-bold">{` ${displayName} `}</span>content
          by interactions
        </div>
        <div>-</div>
        <div className="text-xs place-self-center text-gray-500 hover:text-gray-700">
          <button
            className="underline"
            onClick={() =>
              downloadJsonAsCsv(
                data,
                getCsvFilename(dateRange, appId, "ActivityCount")
              )
            }
          >
            Download data as CSV
          </button>
        </div>
      </div>
      <BasePieChart combineMinimum={combineMinimum} data={data} />
    </>
  ) : (
    <div>
      No data collected for{" "}
      <span className="font-bold">{` ${displayName} `}</span>during the selected
      dates
    </div>
  );
};

export { ModelChart };
